import React, { useEffect, useState } from 'react';

const SITE_BASE = 'https://quillesdehuit.org';
const FOOTER_CONFIG_URL = '/footer/footer.json';

function PartnerLogo({ partner }) {
	const img = (
		<img
			src={partner.image}
			alt={partner.alt}
			width={partner.width}
			height={partner.height}
			loading="lazy"
			decoding="async"
		/>
	);

	if (partner.href) {
		return (
			<a
				href={partner.href}
				target="_blank"
				rel="noopener noreferrer"
				className="quilles-site-footer-partner-link"
			>
				{img}
			</a>
		);
	}

	return <span className="quilles-site-footer-partner-link">{img}</span>;
}

function QuillesSiteFooter() {
	const [partners, setPartners] = useState([]);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				const response = await fetch(FOOTER_CONFIG_URL);
				if (!response.ok) return;
				const config = await response.json();
				if (!cancelled) setPartners(config.partners ?? []);
			} catch {
				/* pied optionnel si manifest indisponible */
			}
		})();
		return () => {
			cancelled = true;
		};
	}, []);

	return (
		<footer className="quilles-site-footer">
			{partners.length > 0 && (
				<div className="quilles-site-footer-partners">
					{partners.map((partner) => (
						<PartnerLogo key={partner.image} partner={partner} />
					))}
				</div>
			)}
			<div className="quilles-site-footer-inner">
				<a
					href={`${SITE_BASE}/mentions-legales.awp`}
					target="_blank"
					rel="noopener noreferrer"
					className="quilles-site-footer-link"
				>
					mentions légales
				</a>
				<span className="quilles-site-footer-link quilles-site-footer-credit">
					&copy;2026 Pit&apos;s BI
				</span>
				<a
					href={`${SITE_BASE}/connexion.awp`}
					target="_blank"
					rel="noopener noreferrer"
					className="quilles-site-footer-link"
				>
					connexion
				</a>
			</div>
		</footer>
	);
}

export default QuillesSiteFooter;
